import React from 'react';

const Soccer = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_12549_47468)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.7381 17.731C11.1802 17.8556 10.6002 17.9213 10.0048 17.9213C9.25604 17.9213 8.53155 17.8174 7.84496 17.6232L7.03625 14.2921C6.99088 14.1052 6.82354 13.9736 6.63124 13.9736H3.15233C2.47442 12.8063 2.08624 11.4499 2.08624 10.0027C2.08624 10.0021 2.08624 10.0014 2.08624 10.0007L5.24467 8.18067C5.40491 8.08833 5.48513 7.90143 5.44169 7.72166L4.5954 4.21979C5.2582 3.59955 6.02769 3.09193 6.87337 2.72744L9.7582 4.8234C9.90427 4.92952 10.1021 4.92952 10.2481 4.8234L13.1342 2.72655C13.9774 3.08967 14.7448 3.59505 15.4064 4.21246L14.457 7.71042C14.4068 7.89519 14.489 8.09036 14.6562 8.1836L17.919 10.0029L17.9234 9.99875C17.9234 10.0001 17.9234 10.0014 17.9234 10.0027C17.9234 11.4499 17.5352 12.8063 16.8573 13.9736H13.3417C13.1643 13.9736 13.0064 14.0859 12.9481 14.2534L11.7381 17.731ZM19.1737 10.0027C19.1737 15.0666 15.0686 19.1716 10.0048 19.1716C4.94098 19.1716 0.835938 15.0666 0.835938 10.0027C0.835938 4.93891 4.94098 0.833862 10.0048 0.833862C15.0686 0.833862 19.1737 4.93891 19.1737 10.0027ZM9.75704 6.84679C9.90311 6.74067 10.1009 6.74067 10.247 6.84679L12.928 8.79466C13.0741 8.90079 13.1352 9.08891 13.0794 9.26062L12.0553 12.4123C11.9995 12.5841 11.8395 12.7003 11.659 12.7003H8.34505C8.1645 12.7003 8.00447 12.5841 7.94868 12.4123L6.92462 9.26062C6.86883 9.08891 6.92995 8.90079 7.07602 8.79466L9.75704 6.84679Z",
      fill: "white"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_12549_47468" }, /* @__PURE__ */ React.createElement("rect", { width: "20", height: "20", fill: "white" })))
);

export { Soccer };
//# sourceMappingURL=Soccer.js.map
